(() => {
  const key = 'norgira:collection:columns';
  const desktop = () => matchMedia('(min-width:1024px)').matches;
  const valid = (value) => (desktop() ? [2,4,6] : [1,2]).includes(value);
  const apply = (root, value, persist = false) => {
    const columns = valid(value) ? value : desktop() ? 4 : 2;
    root.style.setProperty('--norgira-layout-columns', columns);
    root.dataset.layoutColumns = columns;
    root.querySelectorAll('[data-columns]').forEach((button) => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.columns) === columns));
    });
    root.querySelectorAll('.is-options-open').forEach(card => card.classList.remove('is-options-open'));
    if (persist) { try { localStorage.setItem(key, String(columns)); } catch (_) {} }
  };
  const setup = () => document.querySelectorAll('[data-norgira-collection-grid]').forEach(root => {
    if (!root.querySelector('[data-norgira-layout-switch]') || root.dataset.layoutReady) return;
    root.dataset.layoutReady = 'true';
    let stored;
    try { stored = Number(localStorage.getItem(key)); } catch (_) {}
    apply(root, stored);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-norgira-layout-switch] [data-columns]');
    if (!button) return;
    apply(button.closest('[data-norgira-collection-grid]'), Number(button.dataset.columns), true);
  });
  let wasDesktop = desktop();
  addEventListener('resize', () => {
    if (desktop() === wasDesktop) return;
    wasDesktop = desktop();
    let stored;
    try { stored = Number(localStorage.getItem(key)); } catch (_) {}
    document.querySelectorAll('[data-norgira-collection-grid]').forEach(root => apply(root, stored));
  });
  document.addEventListener('shopify:section:load', setup);
  new MutationObserver(setup).observe(document.documentElement, {childList:true,subtree:true});
  setup();
})();
